import React, { useEffect, useRef } from "react";

const COLORS = {
  home: "#1C3F3A",
  train: "#4a6fa5",
  transport: "#2f7dd1",
  monument: "#c9a24b",
  food: "#b5651d",
  park: "#3f8f5a",
  shop: "#8a5a83",
  other: "#777777",
};

// Interactive OpenStreetMap (Leaflet) with markers for the property + nearby POIs/transports.
// Leaflet is dynamically imported so it stays out of the initial JS bundle.
export default function PropertyMap({ center, points = [], address }) {
  const ref = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!center || !ref.current) return;
    let cancelled = false;
    (async () => {
      const L = (await import("leaflet")).default;
      await import("leaflet/dist/leaflet.css");
      if (cancelled || !ref.current) return;
      if (mapRef.current) { mapRef.current.remove(); mapRef.current = null; }

      const map = L.map(ref.current, { scrollWheelZoom: false }).setView([center.lat, center.lng], 15);
      mapRef.current = map;
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "&copy; OpenStreetMap",
        maxZoom: 19,
      }).addTo(map);

      const addMarker = (lat, lng, color, label, big) => {
        const size = big ? 20 : 14;
        const icon = L.divIcon({
          className: "",
          html: `<span style="display:block;width:${size}px;height:${size}px;border-radius:50%;background:${color};border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.45)"></span>`,
          iconSize: [size, size],
          iconAnchor: [size / 2, size / 2],
        });
        L.marker([lat, lng], { icon }).addTo(map).bindPopup(label);
      };

      const bounds = [[center.lat, center.lng]];
      addMarker(center.lat, center.lng, COLORS.home, `<b>${address || "Le logement"}</b>`, true);
      points.forEach((pt) => {
        addMarker(pt.lat, pt.lng, COLORS[pt.category] || COLORS.other, pt.label, false);
        bounds.push([pt.lat, pt.lng]);
      });
      if (bounds.length > 1) map.fitBounds(bounds, { padding: [40, 40], maxZoom: 16 });
      setTimeout(() => map.invalidateSize(), 250);
    })();

    return () => {
      cancelled = true;
      if (mapRef.current) { mapRef.current.remove(); mapRef.current = null; }
    };
  }, [center, points, address]);

  if (!center) return null;
  return <div ref={ref} data-testid="property-map" className="w-full h-full isolate relative z-0" style={{ minHeight: 320 }} />;
}
